import { Retriever, IState, ITimeZoneObservable, IClock } from "../../../../../common";
import { SportModel } from "../../..";
import { SportsBaseRetriever } from "../SportsBaseRetriever";
import { TodaySportBFFQueryFactory, TodaySportApiQueryFactory } from "../../../queries";

export class TodaySportsRetriever extends Retriever<SportModel> {

    private readonly baseRetriever: SportsBaseRetriever;
    private readonly timeZoneObservable: ITimeZoneObservable;
    private readonly clock: IClock;
    private readonly sportBffQueryFactory: TodaySportBFFQueryFactory;
    private readonly sportApiQueryFactory: TodaySportApiQueryFactory;

    constructor (baseRetriever: SportsBaseRetriever, timeZoneObservable: ITimeZoneObservable, clock: IClock, sportBffQueryFactory: TodaySportBFFQueryFactory, sportApiQueryFactory: TodaySportApiQueryFactory) {
        super();
        this.baseRetriever = baseRetriever;
        this.timeZoneObservable = timeZoneObservable;
        this.clock = clock;
        this.sportBffQueryFactory = sportBffQueryFactory;
        this.sportApiQueryFactory = sportApiQueryFactory;
    }

    async activate(state: IState<SportModel>) {
        this.baseRetriever.activate();
        await this.timeZoneObservable.observe((timeZone) => {
            const sportBffQueryFactory = () => {
                const from = this.clock.getBeginningOfTodayForTimeZone(timeZone);
                return this.sportBffQueryFactory(from);
            }
            const sportApiQueryFactory = this.sportApiQueryFactory(() => this.clock.getBeginningOfTodayForTimeZone(timeZone));
            return this.baseRetriever.refresh(state, sportBffQueryFactory, sportApiQueryFactory)
        });
    }

    deactivate() {
        this.baseRetriever.deactivate();
    }
}